import React from "react";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BsXLg } from "react-icons/bs";


const HomeCorousel = () => {


  let settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidersToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  
  };
  return (
    <>
    <div className="w-full relative shadow-lg mx-auto  mt-6">
    <div className="w-full   pb-7 overflow-hidden ">

<Corousel {...settings}>
  <Wrap>
   <img src="/images/comfort.jpg" alt="" />
  </Wrap>
  <Wrap>
<img src="/images/kurta.webp" alt="" />
  </Wrap>
  <Wrap>
  <img src="/images/puma.jpg" alt="" />
  </Wrap>
  <Wrap>
      <img src="/images/safari.jpg" alt="" />
  </Wrap>
  <Wrap>
      <img src="/images/shoes.webp" alt="" />
  </Wrap>
  <Wrap>
      <img src="/images/sportswear.webp" alt="" />
  </Wrap>
  <Wrap>
      <img src="/images/watch.webp" alt="" />
  </Wrap>
</Corousel>
</div>
    </div>
      
    </>
  );
};

const Corousel = styled(Slider)`
  margin-top: 0px;
  & > button {
    opacity: 0;
    height: 100%;
    width: 5vw;
    z-index: 1;
    background-color:blue;
    &:hover {
      opacity: 1;
      
      transition: opacity 0.2s ease 0s;
    }

  }
  ul li button {
     
    &:before {
      font-size: 10px;
      color:black;
    }
  }

  .slick-list {
    overflow: initial;
  }
  .slick-prev {
    left: 0px;

  }
  .slick-next {
    right: 0px;
  }
`;

const Wrap = styled.div`
border-radius:4px;

position:relative;
width:100%:

`;

export default HomeCorousel;
